module.exports = __webpack_public_path__ + "static/img/qrcode1.37fc2d03.jpg";